import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {
  INQUIRY_PROCESS_NAME,
  resolveLatestProcessName,
  isInquiryProcessAlias,
  isNegotiationProcessAlias,
  OFFER,
} from '../../transactions/transaction';

import { Heading, Modal } from '../../components';
import UserCard from './UserCard/UserCard';
import InquiryForm from './InquiryForm/InquiryForm';
import { FaDog, FaCat, FaPaw } from 'react-icons/fa';
import { RiCandleLine } from 'react-icons/ri';

import { NamedLink } from '../../components';
import css from './ListingPage.module.css';
import { PiCatLight, PiDogFill } from 'react-icons/pi';
import { IoInformationCircleOutline } from 'react-icons/io5';
import { IoMdCloseCircleOutline } from 'react-icons/io';

const dogImages = [
  '/static/petAvatars/dog1.png',
  '/static/petAvatars/dog2.png',
  '/static/petAvatars/dog3.png',
  '/static/petAvatars/dog4.png',
  '/static/petAvatars/dog5.png',
];

const catImages = [
  '/static/petAvatars/cat1.png',
  '/static/petAvatars/cat2.png',
  '/static/petAvatars/cat3.png',
  '/static/petAvatars/cat4.png',
  '/static/petAvatars/cat5.png',
];

const CONTACT_USER_LINK = 'inquiryModalContactUserLink';

const SectionAuthorMaybe = props => {
  const {
    title,
    listing,
    authorDisplayName,
    onContactUser,
    isInquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    currentUser,
    onManageDisableScrolling,
    onSendVerificationEmail,
    sendVerificationEmailInProgress,
    emailUnverified,
    onRequestToBook,
    vibeCheckListingExists,
    timeSlots,
    monthlyTimeSlots,
    onFetchTimeSlots,
    dayCountAvailableForBooking,
    start,
    end,
  } = props;

  if (!listing.author) {
    return null;
  }

  const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
  const unitType = listing?.attributes?.publicData?.unitType || '';
  const isInquiryProcess = isInquiryProcessAlias(transactionProcessAlias);
  const isNegotiationProcess = isNegotiationProcessAlias(transactionProcessAlias);

  const showContact = !(isInquiryProcess || (isNegotiationProcess && unitType === OFFER));

  const isBoardingListing = listing?.attributes?.publicData?.listingType === 'boarding';
  const processName = resolveLatestProcessName(transactionProcessAlias.split('/')[0]);

  const [selectedPet, setSelectedPet] = useState(null);
  const tooltipRef = useRef(null);
  const providerPetProfiles =
    listing?.author?.attributes?.profile?.publicData?.providerPetProfiles || [];
  const isProvider = currentUser?.attributes?.profile?.publicData?.userType === 'provider';
  const visiblePets = providerPetProfiles.slice(0, 4);
  useEffect(() => {
    const handleClickOutside = event => {
      if (selectedPet && tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setSelectedPet(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [selectedPet]);
  return (
    <section id="author" className={css.sectionAuthor}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.aboutProviderTitle" />
      </Heading>
      <UserCard
        user={listing.author}
        currentUser={currentUser}
        onContactUser={onContactUser}
        showContact={showContact}
        contactLinkId={CONTACT_USER_LINK}
      />
      {providerPetProfiles.length > 0 ? (
        <div className={css.myPetsSection}>
          <Heading as="h4" rootClassName={css.petsHeading}>
            {isProvider ? 'Meet My Pets' : `Meet ${authorDisplayName}'s Pets`}
          </Heading>

          <div className={css.petGrid}>
            {visiblePets.map((pet, index) => {
              // const avatar =
              //   pet.type === 'dog'
              //     ? dogImages[index % dogImages.length]
              //     : catImages[index % catImages.length];

              return (
                <div
                  key={pet.id}
                  className={css.compactPetCard}
                  onMouseLeave={() => {
                    if (selectedPet?.id === pet.id) {
                      setSelectedPet(null);
                    }
                  }}
                >
                  {/* <img src={avatar} alt={pet.name} className={css.compactPetAvatar} /> */}
                  <div className={css.compactPetAvatar}>
                    {pet.type === 'dog' ? <PiDogFill /> : <PiCatLight />}
                  </div>
                  <div className={css.compactPetContent}>
                    <div className={css.petDetailsRowOne}>
                      {' '}
                      <div className={css.compactPetName}>{pet.name}</div>
                      <button
                        type="button"
                        className={css.aboutPetBtn}
                        onClick={e => {
                          e.stopPropagation();

                          setSelectedPet(selectedPet?.id === pet.id ? null : pet);
                        }}
                      >
                        <IoInformationCircleOutline size={18} />
                      </button>
                      {selectedPet?.id === pet.id ? (
                        <div
                          ref={tooltipRef}
                          className={css.petTooltip}
                          onClick={e => e.stopPropagation()}
                        >
                          <button
                            type="button"
                            className={css.tooltipCloseBtn}
                            onClick={() => setSelectedPet(null)}
                          >
                            <IoMdCloseCircleOutline size={20} />
                          </button>

                          {pet.about}
                        </div>
                      ) : null}
                    </div>
                    <div className={css.petDetailsRowTwo}>
                      <div className={css.petDetail}>
                        {pet.type === 'dog' ? <FaDog /> : <FaCat />}
                        <span>{pet.type === 'dog' ? 'Dog' : 'Cat'}</span>
                      </div>

                      <div className={css.petDetail}>
                        <FaPaw />
                        <span>{pet.breed}</span>
                      </div>
                      <div className={css.petDetail}>
                        <RiCandleLine />
                        <span>
                          {pet.age} {Number(pet.age) === 1 ? 'year' : 'years'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {providerPetProfiles.length > 4 ? (
            <div className={css.viewAllPetsWrapper}>
              <NamedLink
                className={css.viewAllPets}
                name="ProfilePage"
                params={{
                  id: listing.author.id.uuid,
                }}
                to={{
                  hash: '#providerPetsContainer',
                }}
              >
                View All Pets
              </NamedLink>
            </div>
          ) : null}
        </div>
      ) : null}
      <Modal
        id="ListingPage.inquiry"
        contentClassName={css.inquiryModalContent}
        isOpen={isInquiryModalOpen}
        onClose={onCloseInquiryModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
        focusElementId={CONTACT_USER_LINK}
      >
        <InquiryForm
          className={css.inquiryForm}
          submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
          listingTitle={title}
          authorDisplayName={authorDisplayName}
          sendInquiryError={sendInquiryError}
          onSubmit={onSubmitInquiry}
          inProgress={sendInquiryInProgress}
          onSendVerificationEmail={onSendVerificationEmail}
          sendVerificationEmailInProgress={sendVerificationEmailInProgress}
          emailUnverified={emailUnverified}
          onRequestToBook={onRequestToBook}
          isBoardingListing={isBoardingListing}
          vibeCheckListingExists={vibeCheckListingExists}
          timeSlots={timeSlots}
          monthlyTimeSlots={monthlyTimeSlots}
          onFetchTimeSlots={onFetchTimeSlots}
          dayCountAvailableForBooking={dayCountAvailableForBooking}
          start={start}
          end={end}
          timeZone={listing?.attributes?.availabilityPlan?.timezone}
        />
      </Modal>
    </section>
  );
};

export default SectionAuthorMaybe;
